<template>
  <v-row no-gutters align="center">
    <v-col class="d-flex items-center">
      <popover-menu ref="popover" toggleable :config="{ placement: 'bottom-center' }" @change="onTogglePopover">
        <template #activator="{ on }">
          <v-icon v-on="on" small color="primary"> mdi-help-circle </v-icon>
        </template>
        <div class="tw:flexcol-1.5 tw:max-w-[300px]">
          <div class="tw:flexrow-2 tw:justify-between">
            <span class="tw:truncate tw:text-left tw:text-font tw:text-sm tw:font-medium">{{ metadata.name }}</span>
            <v-btn icon x-small @click="closePopover">
              <v-icon small>mdi-close</v-icon>
            </v-btn>
          </div>
          <div class="tw:max-h-[250px] tw:overflow-auto tw:flex tw:justify-start">
            <div v-if="imageStatus !== 'loaded'" class="tw:flex tw:w-full">
              <v-skeleton-loader
                v-if="imageStatus === 'loading'"
                max-height="100px"
                class="tw:h-full tw:grow tw:w-full"
                type="image"
              />
              <span v-else class="tw:text-gray-400 tw:text-xs tw:text-left">
                {{ $i18n.t('sidebar.wmsLegendError') }}
              </span>
            </div>
            <img
              :class="{ 'tw:hidden': imageStatus !== 'loaded' }"
              class="tw:max-w-[unset] tw:shrink-0 tw:h-full"
              :src="legendUrl"
              :alt="`${metadata.name} legend graphic`"
              @error="onError"
              @load="onLoad"
            />
          </div>
        </div>
      </popover-menu>
    </v-col>
  </v-row>
</template>

<script>
import PopoverMenu from '@/components/PopoverMenu';

export default {
  name: 'WmsLegendGraphicPopover',
  components: {
    PopoverMenu,
  },
  props: {
    metadata: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    legendUrl: null,
    imageStatus: 'loading' /** 'loading' | 'loaded' | 'error' */,
  }),
  methods: {
    closePopover() {
      this.$refs.popover?.closePopover();
    },
    onLoad() {
      this.imageStatus = 'loaded';
    },
    onError() {
      this.imageStatus = 'error';
      console.warn(`Error loading WMS GetLegendGraphic for layer "${this.metadata.name}" - ${this.legendUrl}`);
    },
    onTogglePopover(isVisible) {
      this.$emit('change', isVisible, this.metadata);
      if (!isVisible) return (this.imageStatus = 'loading');
      this.$root.$emit('getLayerContextById', {
        id: this.metadata.layer_id,
        group: 'layers',
        callback: (layer, { view }) => {
          const wmsSource = layer.getSource();
          this.legendUrl = wmsSource.getLegendUrl(view.getResolution(), { SLD_VERSION: '1.1.0' });
        },
      });
    },
  },
};
</script>
